<div *ngIf="row">
  Подробная информация о клиенте {{row.rowSrc.name}} возрастом {{row.rowSrc.age}}.
</div>
